import _State from '@states/_State.js';

const OrganizationState = _State('organizations', 'setOrganizations', []);
// add new methods to state if needed

export default OrganizationState;
